const NUM_TABLE = 0;
const NUM_KANBAN = 1;

export default {
  NUM_TABLE,
  NUM_KANBAN
};
